import ProgressBar from 'Components/ProgressBar';

const LoggingIn = () => (
  <>
    <ProgressBar />
    <div className="main">
      <h1 className="page-heading"></h1>
    </div>
  </>
);

export default LoggingIn;
